<template>
  <div>

    <div class="sayfahead">
      <h1>{{Sayfa.Adi}}</h1>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <div class="container-fluid mt-5">
        <el-row :gutter="20">
          <el-col :span="12" :offset="6">
            <el-steps :active="AktifStep" finish-status="success">
              <el-step title="Dosya Seçimi" description="Excel Dosyanızı Seçiniz"></el-step>
              <el-step title="Kontrol & Onay" description="İçe Aktarım için kontrol edin"></el-step>
              <el-step title="Veri Geçişi" description="Aktarım sonucu"></el-step>
            </el-steps>
          </el-col>
        </el-row>
      </div>

      <div v-if="AktifStep===1" class="mt-5">
        <el-row :gutter="20">
          <el-col :span="12" :offset="6">
            <div class="alert alert-info">Şimdi bir tık ile bütün verilerinizi aidatım'a aktarın.<br>
              Hazırladığınız şablon Excel dosyasını ön izlemeli olarak göstereceğiz.
            </div>
            <el-row :gutter="20">
              <el-col :span="18">
                <label for="file" type="button" class="el-button el-button--success btn-block">Excel
                  Dosyası
                  Yükle ve Hazırla <i class="el-icon-upload el-icon-right"></i></label>
                <input type="file" class="el-upload__input" id="file" accept=".xlsx,.xls"
                       @change="ExcelSecimi">
              </el-col>
              <el-col :span="6">
                <a href="https://drive.google.com/uc?authuser=0&id=1Y7LfR0Sb9mFfsZaSEtH6KGygPPNjY8HZ&export=download"
                   target="_blank" class="el-button el-button--primary btn-block">Şablon İndir <i
                  class="el-icon-download el-icon-right"></i></a>
              </el-col>
            </el-row>

          </el-col>
        </el-row>
      </div>

      <div v-if="AktifStep===2" class="mt-5">
        <el-row :gutter="20" class="mb-5">
          <el-col :span="12" :offset="6">
            <div class="alert alert-info">Excel dosyanızı aşağıdaki tabloda derledik<br>
              Kontrol ederek içe aktarabilirsiniz.
            </div>
            <el-row :gutter="20">
              <el-col :span="16">
                <el-button type="primary" @click="AktifStep=1" icon="el-icon-caret-left">Dosya Seçimine
                  Dön
                </el-button>
              </el-col>
              <el-col :span="8">
                <el-button type="success" @click="Onayla" class="float-right" icon="el-icon-check">
                  Onayla ve
                  içe Aktar
                </el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>


        <table class="table table-hover table-sm">
          <thead>
          <tr>
            <th>Site/Bina Adı</th>
            <th>Cari Adı</th>
            <th>Evrak No</th>
            <th>Borçlanma Tarihi</th>
            <th>Son Ödeme Tarihi</th>
            <th>Tutar</th>
            <th>Kategori</th>
            <th>Açıklama</th>
            <th>Ödeme Tarihi</th>
            <th>Kasa</th>
          </tr>

          </thead>
          <tbody>
          <tr v-for="(r, key) in data" v-if="key>0" :key="key">
            <td v-for="c in cols" :key="c.key"> {{ r[c.key] }}</td>
          </tr>
          </tbody>
        </table>

      </div>
      <div v-if="AktifStep===3" class="mt-5">
        <el-row :gutter="20" class="mb-5">
          <el-col :span="12" :offset="6">
            <div class="alert alert-info">Verilerinizin geçişi tamamlandı<br>

            </div>

          </el-col>
        </el-row>
      </div>

    </div>
  </div>
</template>

<script>
  import XLSX from 'xlsx';
  import Yukleniyor from "../../../components/Doc/Yukleniyor";

  const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
    name: XLSX.utils.encode_col(i),
    key: i
  }));
  export default {
    components: {Yukleniyor},
    data() {
      return {
        lo: false,
        Yetki: false,
        ModalOlayi: false,
        AktifStep: 1,
        data: [],
        cols: [],
        Sayfa: {
          ButtonAdi: this.$t('eYonetim.16'),
          Adi: 'Excel ile Gider İşle',
          DuzenleAdi: this.$t('eGenel.10'),
          SilAdi: this.$t('eGenel.11'),
          Arama: this.$t('eGenel.9'),
          Menu: [
            {Adi: 'Gider İşle', Link: '/muhasebe/gider/gider'},
            {Adi: 'Abonelik İşle', Link: '/muhasebe/gider/abonelik'},
          ],
          MenuDisplay: true,
        },
        search: '',
        Liste: [],
        FormData: {
          Baslik: null,
          Sil: false
        },
      }
    },
    methods: {
      Onayla() {
        this.lo = true;
        this.$store.dispatch("Post", {...this.data, path: 'muhasebe/gider/excel/'})
          .then(response => {
            this.lo = false;
            if (response.Durum == "OK") {
              this.$message.success(response.Mesaj);
              this.AktifStep = 3;
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          })
      },
      ExcelSecimi(evt) {
        const files = evt.target.files;
        if (files && files[0]) this._file(files[0]);
      },
      _file(file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const bstr = e.target.result;
          //const wb = XLSX.read(bstr, {type: 'binary'});
          const wb = XLSX.read(bstr, {type: 'binary', cellDates: true, cellNF: false, cellText: false});
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const data = XLSX.utils.sheet_to_json(ws, {raw: false, header: 1, dateNF: "DD-MM-YYYY"});
          //const data = XLSX.utils.sheet_to_json(ws, {header: 1});
          this.data = data;
          this.cols = make_cols(ws['!ref']);
          this.AktifStep = 2;
        };
        reader.readAsBinaryString(file);
      }
    },
    created() {
      this.$store.commit("SayfaBilgi", this.Sayfa);
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Muhasebe/gider/excel.vue